
import React from 'react';

interface StarRatingProps {
  maxStars: number;
  value: number;
  onChange?: (rating: number) => void;
  size?: 'small' | 'medium' | 'large';
  readonly?: boolean;
}

export const StarRating: React.FC<StarRatingProps> = ({
  maxStars = 5,
  value = 0,
  onChange,
  size = 'medium',
  readonly = false
}) => {
  // Determine star size based on the size prop
  const starSizeClass = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-8 h-8'
  }[size];

  // Create an array from 1 to maxStars
  const stars = Array.from({ length: maxStars }, (_, i) => i + 1);

  return (
    <div className="flex items-center">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange?.(star)}
          className={`
            ${readonly ? 'cursor-default' : 'cursor-pointer'}
            p-0.5 focus:outline-none
          `}
          disabled={readonly}
          aria-label={`Rate ${star} out of ${maxStars} stars`}
        >
          <svg 
            className={`${starSizeClass} ${star <= value ? 'text-yellow-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
            />
          </svg>
        </button>
      ))}
    </div>
  );
};
